import { render, staticRenderFns } from "./CreateWeightForm.vue?vue&type=template&id=35cbfbc6"
import script from "./CreateWeightForm.vue?vue&type=script&lang=js"
export * from "./CreateWeightForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports